// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.718.768a2.188 2.188 0 0 0-1.293.634c-.107.107-.243.27-.303.362-.12.189-9.766 17.989-9.91 18.288-.157.328-.196.52-.196.948 0 .303.01.407.052.559a2.271 2.271 0 0 0 1.919 1.673c.288.033 19.738.033 20.026 0a2.242 2.242 0 0 0 1.776-1.29c.098-.209.187-.514.187-.644 0-.044.01-.086.024-.094.013-.008.024-.117.024-.243 0-.146-.009-.222-.024-.213-.014.009-.024-.014-.024-.055 0-.124-.094-.444-.188-.641-.142-.296-9.788-18.097-9.91-18.288-.23-.36-.684-.725-1.077-.868a2.51 2.51 0 0 0-1.083-.128m.09 1.509a.89.89 0 0 0-.34.211c-.062.064-1.594 2.868-4.979 9.116a1786.848 1786.848 0 0 0-4.933 9.138.764.764 0 0 0 .383.938l.113.052h19.896l.113-.052a.764.764 0 0 0 .383-.938c-.025-.063-2.245-4.175-4.933-9.138-3.39-6.257-4.916-9.052-4.978-9.116a.704.704 0 0 0-.497-.223.924.924 0 0 0-.228.012m.052 5.238a.736.736 0 0 0-.548.443l-.057.124.007 3.573.006 3.573.055.103c.07.132.214.276.346.346.087.046.14.055.331.055.192 0 .244-.009.331-.055a.936.936 0 0 0 .346-.346l.055-.103.006-3.573.007-3.573-.057-.124a.793.793 0 0 0-.312-.358c-.09-.053-.144-.069-.34-.098a.84.84 0 0 0-.176.013m-.208 9.783a1.25 1.25 0 0 0-.67.587c-.204.42-.12.936.21 1.27.236.24.461.336.796.34.277.002.471-.06.678-.217.376-.285.53-.705.428-1.165a1.17 1.17 0 0 0-.638-.77c-.14-.067-.183-.075-.42-.081-.206-.005-.29.002-.384.036M.009 20.988c0 .132.004.183.009.113.005-.07.005-.178 0-.24s-.01-.005-.01.127"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const WarningIcon = Icon;
export default WarningIcon;
